import { bigNumberToNumberUNSAFE } from '@lyra/core/utils/bigNumberToNumberUNSAFE'
import useSWR from 'swr'
import { Address } from 'viem'

import delegateErc20Abi from '../abis/delegateErc20Abi'
import { lyraClient } from '../constants/client'
import { PendingUnstake } from '../constants/drv'
import { TokenId } from '../constants/tokens'
import { getLyraTokenAddress } from '../utils/tokens'
import useAuth from './useAuth'

const stDrvTokenAddress = getLyraTokenAddress(TokenId.STDRV)

const fetcher = async (address: Address): Promise<PendingUnstake[]> => {
  const res = await lyraClient.readContract({
    abi: delegateErc20Abi,
    address: stDrvTokenAddress,
    functionName: 'getAllUserRedeems',
    args: [address],
  })
  const pendingUnstakes = res.map((p, i) => ({
    drvAmount: p.deriveAmount,
    stDrvAmount: p.stDeriveAmount,
    endTimestamp: bigNumberToNumberUNSAFE(p.endTime, 0),
    redeemIndex: i,
  }))
  return pendingUnstakes
}

export default function usePendingUnstakes() {
  const { user } = useAuth()
  return useSWR(['PendingUnstake', user?.address], ([_, address]) =>
    address ? fetcher(address) : null
  )
}
